// eslint-disable-next-line no-shadow
export enum DataHooks {
  Root = 'toast',
}
